import { platformApiClient } from '@/services/platform-api-client';
import { createEmailGatewayService } from '@/services/email-gateway.service';

/**
 * Platform Console — Email Gateway API.
 *
 * Deliberately a one-line binding of the shared gateway service factory to the
 * platform client and base path. The Platform Console and the tenant portal use
 * the SAME Gateway Management implementation end to end: same types, same
 * service, same page component — only the client and base path differ.
 */
export const platformEmailGatewayService = createEmailGatewayService(
  platformApiClient,
  '/platform/email-gateways',
);

export type {
  EmailGateway,
  CreateEmailGatewayPayload,
  UpdateEmailGatewayPayload,
  TestEmailPayload,
  TestEmailResult,
} from '@/services/email-gateway.service';
